// src/hooks/usePermission.ts
// Reads a configurable-RBAC feature flag (RolePermissions) for the current
// user's role, from the already-cached hierarchySlice role list (kept live
// via the 'role:updated' socket event — see hierarchySlice.ts). Admins
// always pass: they sit outside the hierarchy chain entirely (FEATURES.md
// §10) and this only gates hierarchy-role feature areas, not admin tooling.
// A role with no `permissions` set (predates this field) defaults to true —
// this must never retroactively hide a feature for existing roles.
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { RolePermissions } from 'types/rbac';

export function usePermission(key: keyof RolePermissions): boolean {
  const { user } = useSelector((s: RootState) => s.auth);
  const { roles } = useSelector((s: RootState) => s.hierarchy);

  if (user?.isAdmin) return true;
  const role = roles.find(r => r._id === user?.roleId);
  return role?.permissions?.[key] ?? true;
}
